import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProgressPage } from '@/features/site/progress-page';

const searchSchema = z.object({
  update: z.boolean().optional().catch(undefined),
  stage: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/progress')({
  validateSearch: searchSchema,
  component: ProgressRoute,
});

function ProgressRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <ProgressPage projectId={projectId} openUpdate={search.update} stageId={search.stage} />;
}
